const defaultResignationRequest = () => ({
  _id: null,
  resignationCandidate: null,
  status: null,
  resignationForm: null,
  resignationType: null,
  resignationReason: null,
  resignationJustification: null,
  expectedDate: null,
  approverMessage: null,
  resignationPosition: null, // DUVIDA: POSITION, ROLE OU BOND ?
  admissionDate: null
})

const state = {
  resignationRequest: defaultResignationRequest()
}

const mutations = {
  SET_RESIGNATION_REQUEST: (state, payload) => {
    state.resignationRequest = { ...state.resignationRequest, ...payload }
  },
  RESET_SELECTED_REQUEST: (state) => {
    state.resignationRequest = defaultResignationRequest()
  }
}

const actions = {
  load({ commit }, resignationRequest) {
    commit('SET_RESIGNATION_REQUEST', resignationRequest)
  },
  clear({ commit }) {
    commit('SET_RESIGNATION_REQUEST', defaultResignationRequest())
  },
  setResignationRequest({ commit }, resignationRequest) {
    commit('SET_RESIGNATION_REQUEST', resignationRequest)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
